// contains configuration options used to render the Chart.js charts for a user-created polygon (park) or polyline (trail).

// since attributes, e.g. SUM_TOTPOPSVCA, come from the GP service where they are all caps and are not affected by any 
// underlying database changes, we do not import dataFields to convert field values like in other chart/report configs

export const options = (labels: any) => {
  return ({
    maintainAspectRatio: false,
    indexAxis: "y" as const,
    scales: {
      y: {
        stacked: true,
        ticks: {
          font: {
            size: 11,
          },
          callback: (e: any) => {
            // Custom callback function to wrap labels to a maximum line length of 15 characters
            // Access the label at the correct index
            const label = labels[e]
            // If the label is less than or equal to 15 characters in length, return that label
            if (label.length <= 15) {
              return label
            } else {
              let startIndex = 0
              const labelArray = []
              // Iterate over the label string and add substrings of 15 characters or less, separated by space characters
              while (startIndex < label.length) {
                let endIndex = startIndex + 15;
                if (endIndex + 1 >= label.length) {
                  labelArray.push(label.substring(startIndex).trim())
                } else {
                  while (endIndex > startIndex && label[endIndex] !== ' ') {
                    endIndex--;
                  }
                  if (endIndex === startIndex) {
                    endIndex = startIndex + 15
                  }
                  labelArray.push(label.substring(startIndex, endIndex).trim());
                }
                startIndex = endIndex + 1;
              }
              return labelArray
            }
          }
        },
      },

      x: {
        stacked: true,
        ticks: {
          callback: function (value: any, index: any, ticks: any) {
            return value;
          },
        },
        min: 0,
      },
    },
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    redraw: true,
    plugins: {
      title: {
        display: false,
        text: "Access Demographics",
      },
      legend: {
        display: false,
      },
      datalabels: {
        display: true,
        color: "black",
        formatter: function (val: any) {
          return val.toLocaleString();
        },
      },
    },
  })
};

export const demographicsInServiceArea: any = [
  {
    displayName: "White*",
    value: "SUM_WHITE_SVC",
    new: "SUM_WHITE_SVC",
    total: "SUM_WHITE",
    amount: 0,
  },
  {
    displayName: "Black*",
    value: "SUM_BLACK_SVC",
    new: "SUM_BLACK_SVC",
    total: "SUM_BLACK",
    amount: 0,
  },
  {
    displayName: "Native American*",
    value: "SUM_AMERINDSVC",
    new: "SUM_AMERINDSVC",
    total: "SUM_AMERIND",
    amount: 0,
  },
  {
    displayName: "Asian*",
    value: "SUM_ASIAN_SVC",
    new: "SUM_ASIAN_SVC",
    total: "SUM_ASIAN",
    amount: 0,
  },
  {
    displayName: "Pacific Islander*",
    value: "SUM_PACIFICSVC",
    new: "SUM_PACIFICSVC",
    total: "SUM_PACIFIC",
    amount: 0,
  },
  {
    displayName: "Other Race*",
    value: "SUM_OTHRACESVC",
    new: "SUM_OTHRACESVC",
    total: "SUM_OTHRACE",
    amount: 0,
  },
  {
    displayName: "Two or More Races*",
    value: "SUM_RACE2UPSVC",
    new: "SUM_RACE2UPSVC",
    total: "SUM_RACE2UP",
    amount: 0,
  },
  {
    displayName: "Hispanic",
    value: "SUM_HISP_SVC",
    new: "SUM_HISP_SVC",
    total: "SUM_HISP",
    amount: 0,
  },
];

export const ageGroupInServiceArea: any = [
  {
    displayName: "Youth (<20)",
    value: "SUM_KIDS_SVCA",
    new: "SUM_KIDSVCA",
    total: "SUM_KIDS",
    amount: 0,
  },
  {
    displayName: "Adults (20-64)",
    value: "SUM_YOUNG_PRO_SVCA",
    new: "SUM_YOUNGPROSVCA",
    total: "SUM_YOUNG_PRO",
    amount: 0,
  },
  {
    displayName: "Seniors (>64)",
    value: "SUM_SENIORS_SVCA",
    new: "SUM_SENIORSVCA",
    total: "SUM_SENIORS",
    amount: 0,
  },
];

export const incomeGroupInServiceArea: any = [
  {
    displayName: "Low Income (<75% MAI)",
    value: "SUM_HHILOWSVCA",
    new: "SUM_HHILOWSVCA",
    total: "SUM_TPLHHILOW",
    amount: 0,
  },
  {
    displayName: "Medium Income (75%-125% MAI)",
    value: "SUM_HHIMEDSVCA",
    new: "SUM_HHIMEDSVCA",
    total: "SUM_TPLHHIMED",
    amount: 0,
  },
  {
    displayName: "High income (>125% MAI)",
    value: "SUM_HHIHGHSVCA",
    new: "SUM_HHIHGHSVCA",
    total: "SUM_TPLHHIHGH",
    amount: 0,
  },
];

export const demoLabels = [
  "White*",
  "Black*",
  "American Indian*",
  "Asian*",
  "Pacific Islander*",
  "Other Race*",
  "Two or More Races*",
  "Hispanic",
];

export const ageLabels = ["Youth (<20)", "Adults (20-64)", "Seniors (>64)"];

export const incomeLabels = [
  "Low Income (<75% MAI)",
  "Medium Income (75%-125% MAI)",
  "High income (>125% MAI)",
];

export const colors1 = [
  "#E7F4B8",
  "#BEDA58",
  "#5DBA54",
  "#1D8363",
  "#57C5F8",
  "#2EA0D4",
  "#1989BC",
];

export const colors2 = [
  "#BEDA58",
  "#5DBA54",
  "#1D8363",
  "#57C5F8",
  "#2EA0D4",
  "#1989BC",
  "#E7F4B8",
];
